import HeaderI18n from './Header.i18n.js';
import {
  Slide
} from 'vue-burger-menu'
import {
  mapGetters
} from 'vuex'
export default {

  components: {
    Slide
  },
  computed: {
    ...mapGetters(['cart', 'user']),
    routeName() {
      return this.$route.name
    },
    cartLength() {
      let total = 0 
      this.cart.forEach(aArticle => {
        total = total + parseInt(aArticle.quantite)
      })
      return total
    }
  },
  props: {},

  data() {
    return {};
  },

  watch: {},

  methods: {
    /**
     * Get the number of cart item.
     */
 
    /**
     * Function to go to cart page.
     */
    goToCart() {
      this.$router.push({
        path: `/panier`
      })
    },
    /**
     * Function to go to home page.
     */
    goToHome() {
      this.$router.push({
        path: `/`
      })
    },
    /**
     * Function to go to mon compte.
     */
    goToMonCompte() {
      this.$router.push({
        path: `/mon-compte`
      })
    },
    goToLoginInscription() {
      this.$router.push({
        path: `/login`
      })
    }

  },

  mounted() {},

  i18n: HeaderI18n,

};